import type { HostedSite } from '../data/hostingSites';

export function getSiteVisitKey(site: HostedSite): string {
  if (site.visitKey) return site.visitKey;
  return site.url ?? site.name;
}

export function mergeSitesWithStoredVisits(
  sites: HostedSite[],
  counts: Record<string, number>
): HostedSite[] {
  return sites.map((site) => {
    const key = getSiteVisitKey(site);
    const extra = counts[key] ?? (site.url ? counts[site.url] : undefined) ?? counts[site.name] ?? 0;
    return { ...site, monthlyVisits: site.monthlyVisits + extra };
  });
}
